/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * リリースノート
 * @export
 * @interface ReleaseNoteRow
 */
export interface ReleaseNoteRow {
    /**
     * リリースノートID
     * @type {number}
     * @memberof ReleaseNoteRow
     */
    id: number;
    /**
     * タイトル
     * @type {string}
     * @memberof ReleaseNoteRow
     */
    title: string;
    /**
     * 本文
     * @type {string}
     * @memberof ReleaseNoteRow
     */
    body: string;
    /**
     * 画像があるか
     * @type {boolean}
     * @memberof ReleaseNoteRow
     */
    hasImage: boolean;
    /**
     * 画像の拡張子
     * @type {string}
     * @memberof ReleaseNoteRow
     */
    imageExt: string;
    /**
     * 公開日時
     * @type {string}
     * @memberof ReleaseNoteRow
     */
    publishedAt: string;
}

export function ReleaseNoteRowFromJSON(json: any): ReleaseNoteRow {
    return ReleaseNoteRowFromJSONTyped(json, false);
}

export function ReleaseNoteRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReleaseNoteRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'body': json['body'],
        'hasImage': json['has_image'],
        'imageExt': json['image_ext'],
        'publishedAt': json['published_at'],
    };
}

export function ReleaseNoteRowToJSON(value?: ReleaseNoteRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'body': value.body,
        'has_image': value.hasImage,
        'image_ext': value.imageExt,
        'published_at': value.publishedAt,
    };
}


